/**
 * Datum zadnje verzije aplikacije.
 *
 * Upisuje ga `npm run build` (REACT_APP_VERZIJA_DATUM), pa ne može zastariti
 * — ono što piše u podnožju je datum kad je ta verzija stvarno napravljena.
 */
export const VERZIJA_DATUM: string =
  process.env.REACT_APP_VERZIJA_DATUM || 'razvojna verzija';
